import type { TersaSpeechModel } from './types';

export function getSpeechVoiceLabel(
  model: TersaSpeechModel | undefined,
  voiceId: string,
  t: (key: string) => string,
): string {
  if (!model || !voiceId) return voiceId;

  if (model.voiceLabelPrefix) {
    const key = `${model.voiceLabelPrefix}.${voiceId}`;
    const translated = t(key);
    if (translated !== key) return translated;
  }

  return model.voiceLabels?.[voiceId] ?? voiceId;
}
